import { Expose, Transform } from 'class-transformer';
import { DeviceSetting } from './device-setting';
import { Rgba } from 'ngx-color-picker';

export class BackLightColorSetting extends DeviceSetting {
    @Expose()
    @Transform((value: Record<string, any>) => Object.assign({}, {
        r: value.r,
        g: value.g,
        b: value.b,
        a: value?.a != null ? value.a : 1.0
    }))
    rgba: Rgba;

    getSettingValue(): Record<string, any> { return this.rgba;};

    setSettingValue(settingValue: Record<string, any>): void {
        this.rgba = settingValue as Rgba;
    }
}
